/* © CNES */
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { InnerSlider } from './InnerSlider/InnerSlider';

/**
 * Slider Cloud Props.
 */
export interface SliderCloudProps {
  handleChange: (e: any, key: string) => void;
}

/**
 * SliderCloud displays a filter section for cloud coverage.
 * @param handleChange handle change on cloud cover.
 * @returns SliderCloud Element.
 */
export const SliderCloud = ({ handleChange }: SliderCloudProps) => {
  /**
   * set new values of cloud Cover.
   * @param value cloud Cover lower and upper value.
   */
  const onChangeCloudCover = (value: number[]) => {
    handleChange(value, filterSections.cloudCover.param);
  };

  return (
    <div className="cloudCoverFilter">
      <CustomAccordion
        title={filterSections.cloudCover.title}
        children={<InnerSlider handleChange={onChangeCloudCover} />}
      />
    </div>
  );
};
